export default "__VITE_ASSET__CCV2JTCE__"